import { Box } from '@wix/design-system';
import React, { forwardRef, useMemo } from 'react';

import { MESSAGES } from '../../../../constants';
import { TItem } from '../../../common/reducers/types';
import { BotAvatar } from '../BotAvatar';
import s from './ChatMessage.scss';
import { router } from './router';
import { ExtraChatMessageProps } from './types';

export type ChatMessageProps = {
  item: TItem;
} & ExtraChatMessageProps;

const liveChatMessageTypes = [
  MESSAGES.CHANGE_MODE,
  MESSAGES.AGENT_STATUS,
  MESSAGES.AGENT_MESSAGE,
  MESSAGES.CHAT_TRANSFERRED,
  MESSAGES.WAITING_FOR_AGENT,
  MESSAGES.CONNECTING_AGENT,
];

export const ChatMessage = forwardRef<HTMLDivElement, ChatMessageProps>(
  ({ item, isFirstInGroup, onLoad, scrollToFn }, ref) => {
    const Message = router(item.type);

    const avatar = useMemo(() => {
      if (!isFirstInGroup) {
        return null;
      }

      if (
        liveChatMessageTypes.includes(item.type) ||
        // Not showing user avatar for user messages
        item.type === MESSAGES.USER_MESSAGE ||
        // BotTyping component is responsible for rendering it's own avatar
        item.type === MESSAGES.BOT_TYPING
      ) {
        // Agent avatar is rendered in AgentMessage
        return null;
      }

      return <BotAvatar />;
    }, [isFirstInGroup, item.type]);

    return (
      <Box className={s.fadeIn} ref={ref} direction="vertical" gap="SP1">
        {avatar}
        <Message {...item} isFirstInGroup={isFirstInGroup} onLoad={onLoad} scrollToFn={scrollToFn} />
      </Box>
    );
  },
);
